import { render, staticRenderFns } from "./MoveBillModal.vue?vue&type=template&id=07990cdf&scoped=true&"
import script from "./MoveBillModal.vue?vue&type=script&lang=js&"
export * from "./MoveBillModal.vue?vue&type=script&lang=js&"
import style0 from "./MoveBillModal.vue?vue&type=style&index=0&id=07990cdf&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07990cdf",
  null
  
)

export default component.exports